/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'x': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 18L18 6M6 6l12 12"/>'
  }
})
